<template>
    <section>
        <sort :sorts="sorts" path="contests"></sort>
        <div class="video-box df jcsb">
            <router-link v-for="v in contests" :key="v.id" :to="`/contests/${v.id}`" class="video-link">
                <div class="video-thumb" :style="`background-image: url(${v.thumb})`">
                    <div class="video-meta">
                        <div class="video-meta-play">
                            <i class="icon-play"></i>{{$view(v.views)}}
                        </div>
                        <i class="icon-time"></i>{{$date(v.addtime)}}
                    </div>
                </div>
                <div class="video-title">{{v.title}}</div>
            </router-link>
        </div>
        <a v-show="!isLoading" class="empty download" href="http://a.app.qq.com/o/simple.jsp?pkgname=com.vhiphop.app">查看全部赛事，请下载 Vhiphop 客户端 >></a>
    </section>
</template>

<script>
    import sort from '../base/Nav';

    export default {
        components: {
            sort,
        },
        data: () => ({
            sorts: ['齐舞比赛', 'Battle比赛', '专题'],
            contests: [],
            isLoading: true,
        }),
        computed: {
            sort() {
                return this.$route.query.sort || 0;
            },
            state() {
                return this.$store.state;
            }
        },
        beforeRouteUpdate(to, from, next) {// 路由改变前，组件就已经渲染完了
            const {sort} = to.query;
            this.api.get('contests', {sort: sort || 0}).then(e => this.contests = e.contests);
            this.$share('赛事');
            next();
        },
        async beforeMount() {
            const {api, sort} = this;

            await Promise.all([
                api.get('contests/sorts').then(e => this.sorts = e),
                api.get('contests', {sort}).then(e => this.contests = e.contests)
            ]).catch(this.err);
            this.isLoading = false;

            this.$share('赛事');

            /*let {sorts, state} = this, l = sorts.length;
            state.cover = state.defaultCover;
            while(l--) {
                if (sorts[l].id === sort) {
                    state.title = `${sorts[l].name}-Vhiphop 唯舞`;
                }
            }*/
        },
    }
</script>

<style scoped>
    @import '../../../static/css/home/video-list.css';
</style>


// WEBPACK FOOTER //
// src/components/home/Contest.vue